import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from './getAccountScopeUserSettings';

export default function getUserEmailAddress(mailboxInfo: MailboxInfo): string | undefined {
    return getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress;
}
